import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";

function PipelineCompanyNotesModal({ onClose, companyInfoId }) {
  const [note, setNote] = useState("");
  const [reminderDate, setReminderDate] = useState("");
  const [notes, setNotes] = useState([]);
  const [editNoteId, setEditNoteId] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  console.log(reminderDate);

  const getNotes = async () => {
    const response = await axios.get(
      `${API_BASE_URL}/companyinfo/getPipelineNotes/${companyInfoId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    setNotes(response.data);
  };

  useEffect(() => {
    if (companyInfoId) {
      getNotes();
    }
  }, [companyInfoId]);

  const saveNote = async () => {
    if (!note.trim()) {
      alert("Note cannot be empty.");
      return;
    }
    let response = null;
    if (editNoteId) {
      response = await axios.put(
        `${API_BASE_URL}/companyinfo/updatePipelineNote/${editNoteId}`,
        {
          note,
          reminder_date: reminderDate || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } else {
      response = await axios.post(
        `${API_BASE_URL}/companyinfo/addPipelineNote/${companyInfoId}`,
        {
          note,
          reminder_date: reminderDate || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    }

    setNote("");
    setReminderDate("");

    getNotes();

    if (response.status === 200) {
      toastr.success(response.data.message);
    }
  };

  return (
    <div className={`modal fade show d-block`} tabIndex="-1">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Notes ({notes.length})</h5>

            <button
              className="btn-close"
              onClick={() => {
                onClose?.();
              }}
            />
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Note</label>

              <textarea
                className="form-control"
                rows={4}
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Reminder Date (Optional)</label>

              <input
                type="date"
                className="form-control"
                value={reminderDate}
                onChange={(e) => setReminderDate(e.target.value)}
              />
            </div>

            <button className="btn btn-primary" onClick={saveNote}>
              {editNoteId ? "Update Note" : "Save Note"}
            </button>

            <hr />

            <div
              className="card"
              style={{
                maxHeight: "100px",
                overflowY: "auto",
              }}
            >
              {notes.map((item) => (
                <div
                  key={item.id}
                  className="card-body p-3 bg-default bg-opacity-10 border border-dark border-opacity-10 rounded mb-1 text-muted pb-0 pt-2 mb-2"
                >
                  <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                    <small className="text-muted d-block">
                      {new Date(item.created_at)
                        .toLocaleString("en-CA")
                        .slice(0, 10)}
                    </small>

                    {item.reminder_date && (
                      <div className="d-flex gap-1">
                        <small className="badge rounded-pill bg-outline-warning text-warning">
                          <i className="fa-regular fa-bell me-1"></i>
                          {new Date(item.reminder_date)
                            .toLocaleString("en-CA")
                            .slice(0, 10)}
                        </small>
                        {item.reminder_sent === 1 && (
                          <small className="badge rounded-pill bg-outline-success text-success">
                            <i className="fa-regular fa-bell me-1"></i>
                            Reminder Sent
                          </small>
                        )}
                      </div>
                    )}
                  </div>

                  <p className="mb-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary rounded-pill me-1"
                      style={{
                        fontSize: "10px",
                        padding: "4px 6px 4px 6px",
                      }}
                      onClick={() => {
                        setEditNoteId(item.id);
                        setNote(item.note);
                        setReminderDate(
                          item.reminder_date
                            ? item.reminder_date?.slice(0, 10)
                            : "",
                        );
                      }}
                    >
                      <i className="fa-solid fa-pen"></i>
                    </button>

                    {item.note}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PipelineCompanyNotesModal;
